import Head from 'next/head'
import { useTranslation } from 'next-i18next'
import { getStaticPaths, makeStaticProps } from 'lib/getStatic'
import MainLayout from 'components/layouts/MainLayout'

export default function Services() {
  const { t } = useTranslation('services')

  return (
    <>
      <Head>
        <title>{t('title')}</title>
        <meta name="description" content={t('description')} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="shortcut icon" type="image/x-icon" href="favicon.ico?" />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
        <link
          rel="alternate"
          hrefLang="de"
          href="https://www.kroemtech.ch/de/dienstleistungen/"
        />
        <link
          rel="alternate"
          hrefLang="en"
          href="https://www.kroemtech.ch/en/services/"
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href="https://www.kroemtech.ch/de/dienstleistungen/"
        />
      </Head>
      <main style={{ fontFamily: 'Verdana, sans-serif' }}>
        <MainLayout view="services" />
      </main>
    </>
  )
}

const getStaticProps = makeStaticProps(['common', 'services'])
export { getStaticPaths, getStaticProps }
